"use client"

import { Button } from "@/components/ui/button"
import Link from "next/link"
import Image from "next/image"
import { useLanguage } from "@/lib/language-context"

export function HeroSection() {
  const { t } = useLanguage()
  return (
    <section className="relative overflow-hidden bg-primary py-20 sm:py-32">
      <div className="mx-auto max-w-[98%] px-4 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          <div className="space-y-6">
            <h1 className="text-4xl font-bold tracking-tight text-primary-foreground sm:text-5xl xl:text-6xl">
              {t("hero.title")}
            </h1>
            <p className="text-lg text-primary-foreground/90" spellCheck={false}>
              {t("hero.subtitle")}
            </p>

            <div className="flex flex-col gap-4 sm:flex-row">
              <Link href="/products">
                <Button size="lg" className="w-full sm:w-auto bg-[#3462c0] hover:bg-[#3462c0]/90 text-white">
                  {t("hero.browse")}
                </Button>


              </Link>
              <Link href="/contact">
                <Button
                  size="lg"
                  variant="outline"
                  className="w-full sm:w-auto border-primary-foreground text-primary-foreground hover:bg-primary-foreground hover:text-primary bg-transparent"
                >
                  {t("hero.contact")}
                </Button>
              </Link>
            </div>
          </div>
          <div className="relative hidden lg:block aspect-square">
            <div className="aspect-square rounded-lg bg-gradient-to-br from-primary-foreground/20 to-primary-foreground/5 overflow-hidden relative w-full h-full">
              <Image
                src="/industrial-parts-warehouse.jpg"
                alt="Industrial parts warehouse"
                fill
                priority
                fetchPriority="high"
                sizes="(max-width: 1024px) 100vw, 600px"
                className="h-full w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
